<template>
  <page :showHeader="false">
    <template v-if="election && currentModel">
      <!-- <span slot="page-title" v-if="type === 'house'"><span style="font-weight:300">House Seat: </span>{{ title }}</span>
      <span slot="page-title" v-if="type === 'senate'"><span style="font-weight:300">Senate Seat: </span>{{ title }}</span> -->

      <v-layout row wrap>
        <v-flex xs12>
          <detail-overview :election="election" :model="currentModel" :chamber="type" class="mb-5"></detail-overview>
        </v-flex>

        <!-- <v-flex xs12 class="mt-5">
          <h2 class="section-title mb-2">Win Probability Over Time</h2>
          <div class="section-description mb-4">The chart below displays our model's probability estimates for this seat since June 19th. Changes can occur due to updated variables such as FEC quarterly reports, national environment changes, or new polling.</div>
        </v-flex> -->

        <template v-if="mobile">
          <v-flex xs12>
            <div v-if="scoreboardData" class="mb-3">
              <div class="detail-scoreboard detail-scoreboard-title">{{ scoreboardData.currentDate || scoreboardData.date | date }}</div>
              <div class="detail-scoreboard detail-scoreboard-teams">
                <div class="detail-team-republicans">
                  <div class="detail-team-name" style="color: #FA3138;">Republicans</div>
                  <div class="detail-team-score" style="color: #FA3138;">{{ scoreboardData.rep.toFixed(1) }}%</div>
                </div>
                <div class="detail-team-republicans">
                  <div class="detail-team-name" style="color: #66ABCF;">Democrats</div>
                  <div class="detail-team-score" style="color: #66ABCF;">{{ scoreboardData.dem.toFixed(1) }}%</div>
                </div>
              </div>
              <div class="detail-scoreboard detail-scoreboard-countdown">
                <span class="mr-2">Days To Election:</span>
                <span style="color: #57AEA6; font-weight: 700;">{{ daysTillElection }}</span>
              </div>
            </div>
          </v-flex>
        </template>

        <template v-else>
          <v-flex xs12>
          <div v-if="scoreboardData">
            <div class="detail-scoreboard detail-scoreboard-teams">
              <div class="detail-team-republicans">
                <div class="detail-team-name" style="color: #FA3138;">Republicans</div>
                <div class="detail-team-score" style="color: #FA3138;">{{ scoreboardData.rep.toFixed(1) }}%</div>
              </div>
              <div>
                <div class="detail-scoreboard detail-scoreboard-title">{{ scoreboardData.currentDate || scoreboardData.date | date }}</div>
                <div class="detail-scoreboard detail-scoreboard-countdown">
                  <span class="mr-2">Days To Election:</span>
                  <span style="color: #57AEA6; font-weight: 700;">{{ daysTillElection }}</span>
                </div>
              </div>
              <div class="detail-team-republicans">
                <div class="detail-team-name" style="color: #66ABCF;">Democrats</div>
                <div class="detail-team-score" style="color: #66ABCF;">{{ scoreboardData.dem.toFixed(1) }}%</div>
              </div>
            </div>
          </div>
        </v-flex>
        </template>

        <v-flex xs12 class="mb-5">
          <time-series :key="election.raceId" @scoreboard-update="scoreboardData = $event" :data="models" prop="gopWinProbability" :customToggle="true" :timelineLength="timelineLength"></time-series>
        </v-flex>

        <v-flex xs12>
          <detail-notes :election="election" :currentModel="currentModel" :currentDate="currentDate" :models="models"></detail-notes>
        </v-flex>

        <v-flex xs12 class="mt-4">
          <h2 class="section-title mb-2">{{ title }} Designated Market Areas</h2>
          <div class="section-description mb-4">The map below shows the Designated market areas (DMAs) for this seat's geography. A DMA is an area that receives similar broadcasting for tv and radio.</div>
        </v-flex>

        <v-flex xs12 class="mb-5">
          <leaflet-map :key="election.id" :type="type" :geoid="election.geoid" :state="election.state"></leaflet-map>
        </v-flex>
      </v-layout>
    </template>
    <template v-if="election && !currentModel && !loading">
      <h4>No Model</h4>
    </template>
    <template v-if="!election && !loading">
      <h4>No Election</h4>
    </template>
    <loading v-if="loading" class="mt-5" :loading="loading" text="Loading Models"></loading>
  </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Page from './Page'
import { LeafletMap, TimeSeries } from '@/components/charts'
import { OptiCard } from '@/components/optimus'
import Loading from '@/components/common/Loading'
import DetailOverview from './detail/Overview'
import DetailNotes from './detail/Notes'

const name = 'detail_wrapper'

const props = {
  type: {
    type: String,
    required: false
  }
}

const computed = {
  ...mapGetters({
    currentDate: 'aggregateModels/currentDate',
    elections: 'elections/list',
    electionModels: 'electionModels/list',
    mobile: 'ux/mobile'
  }),
  title () {
    return this.type === 'house' ? `${this.election.state} ${this.election.cd}` : `${this.election.state}`
  },
  election () {
    if (this.type === 'house') {
      return this.elections.find(election => election.raceId === this.raceId && election.specialElection !== true)
    } else {
      return this.elections.find(election => election.raceId === this.raceId)
    }
  },
  models () {
    return this.electionModels.filter(model => model.election.raceId === this.raceId)
  },
  currentModel () {
    return this.models.find(model => model.date === this.currentDate)
  },
  raceId () {
    return this.$route.params.raceId
  },
  daysTillElection () {
    const election = new Date('2018-11-06')
    let diff = null
    if (this.mobilePhone) {
      diff = election - this.scoreboardData.date
    } else {
      const date = this.scoreboardData.currentDate ? this.scoreboardData.currentDate : this.scoreboardData.date
      election.setHours(12, 0, 0, 0)
      date.setHours(0, 0, 0, 0)
      diff = Math.round(election - date)
    }
    let days = diff / 1000 / 60 / 60 / 24
    if (days < 0) {
      days = 0
    }
    return days.toFixed(0)
  }
}

const methods = {
  ...mapActions({
    getElectionModels: 'electionModels/list'
  }),
  getElectionData () {
    this.loading = true
    this.getElectionModels(this.raceId).then(() => {
      this.loading = false
    })
  }
}

const watch = {
  raceId () {
    this.getElectionData()
  }
}

const components = {
  LeafletMap,
  Loading,
  OptiCard,
  Page,
  DetailOverview,
  DetailNotes,
  TimeSeries
}

export default {
  name,
  props,
  computed,
  methods,
  watch,
  components,
  data () {
    return {
      loading: false,
      id: parseInt(this.$route.params.id, 10),
      scoreboardData: null,
      timelineLength: 'full'
    }
  },
  beforeMount () {
    this.getElectionData()
  }
}
</script>

<style>
.detail-scoreboard {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 800px;
  text-transform: uppercase;
}

.detail-scoreboard-title {
  justify-content: center;
  font-weight: 700;
  font-size: 1.2em;
}

.detail-scoreboard-teams {
  justify-content: space-around;
  align-items: center;
  text-align: center;
}

.detail-team-name {
  letter-spacing: 0.05em;
  font-weight: 500;
  font-size: 1em;
}

.detail-team-score {
  font-weight: 700;
  font-size: 2.2em;
  letter-spacing: 0em;
}

.detail-scoreboard-countdown {
  justify-content: center;
  font-weight: 400;
  font-size: 1em;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/DetailWrapper.vue